export const ALL_ACADEMIC_DISCIPLINES = [
  'Computer Science',
  'Data Science and Machine Learning Engineering',
  'Aeronautical Engineering',
  'Biotechnology Engineering',
  'Chemical Engineering',
  'Civil Engineering',
  'Electrical Engineering',
  'Electronics and Communications Engineering',
  'Information Technology Engineering',
  'Mechanical Engineering',
  'Emerging in Engineering',
  'Hands On Learning for Computer Science, Data Science, and Engineering',
  'Masters in Business Administration',
  'Hands On Learning for Business Skills',
  'Sciences',
  'Healthcare and Life Sciences',
  'Law',
  'Career Skills',
];

export const COURSERA_FOR_CAMPUS_BASIC_SETUP_PATH = 'coursera-for-campus-basic-setup';
export const FREEMIUM_PROGRAM_SETUP_PATH = 'freemium-program-setup';
export const FREEMIUM_INVITE_LEARNERS_PATH = 'freemium-invite-learners';
export const FREEMIUM_PROGRAM_SURVEY_PATH = 'freemium-program-survey';
